export const type = {
    MANAGE_NUMBERS_LOADING: "MANAGE_NUMBERS_LOADING",
    MANAGE_PAGINATE_LOADING: "MANAGE_PAGINATE_LOADING",
    MANAGE_NUMBERS_SUCCESS: "MANAGE_NUMBERS_SUCCESS",
    MANAGE_NUMBERS_FAILED: "MANAGE_NUMBERS_FAILED",
    MANAGE_NUMBERS_RESET: "MANAGE_NUMBERS_RESET",
    MANAGE_NUMBERS_FILTER_APPLY: "MANAGE_NUMBERS_FILTER_APPLY",
    MANAGE_NUMBERS_FILTER_REMOVE: "MANAGE_NUMBERS_FILTER_REMOVE",
    MANAGE_NUMBERS_PAGINATE_SUCCESS: "MANAGE_NUMBERS_PAGINATE_SUCCESS",
    MANAGE_NUMBERS_PAGINATE_LOADING: "MANAGE_NUMBERS_PAGINATE_LOADING",
    MANAGE_NUMBERS_FILTER_SUCCESS: "MANAGE_NUMBERS_FILTER_SUCCESS",
    MANAGE_NUMBERS_FILTER_LOADING: "MANAGE_NUMBERS_FILTER_LOADING",

    CANCEL_NUMBER_SUBSCRIPTION_INIT: "CANCEL_NUMBER_SUBSCRIPTION_INIT",
    CANCEL_NUMBER_SUBSCRIPTION_SUCCESS: "CANCEL_NUMBER_SUBSCRIPTION_SUCCESS",
    CANCEL_NUMBER_SUBSCRIPTION_FAILED: "CANCEL_NUMBER_SUBSCRIPTION_FAILED",

    NUMBER_TYPE_LOADING: "NUMBER_TYPE_LOADING",
    NUMBER_TYPE_SUCCESS: "NUMBER_TYPE_SUCCESS",
    NUMBER_TYPE_FAILED: "NUMBER_TYPE_FAILED",

    CAPABILITY_LIST_LOADING: "CAPABILITY_LIST_LOADING",
    CAPABILITY_LIST_SUCCESS: "CAPABILITY_LIST_SUCCESS",
    CAPABILITY_LIST_FAILED: "CAPABILITY_LIST_FAILED",

    SUBSCRIPTION_STATUS_LOADING: "SUBSCRIPTION_STATUS_LOADING",
    SUBSCRIPTION_STATUS_SUCCESS: "SUBSCRIPTION_STATUS_SUCCESS",
    SUBSCRIPTION_STATUS_FAILED: "SUBSCRIPTION_STATUS_FAILED",

    SUBSCRIPTION_SUB_STATUS_LOADING: "SUBSCRIPTION_SUB_STATUS_LOADING",
    SUBSCRIPTION_SUB_STATUS_SUCCESS: "SUBSCRIPTION_SUB_STATUS_SUCCESS",
    SUBSCRIPTION_SUB_STATUS_FAILED: "SUBSCRIPTION_SUB_STATUS_FAILED",

    DOC_RESUBMIT_INIT: "DOC_RESUBMIT_INIT",
    DOC_RESUBMIT_SUCCESS: "DOC_RESUBMIT_SUCCESS",
    DOC_RESUBMIT_FAILED: "DOC_RESUBMIT_FAILED",

    DOC_LIST_LOADING: "DOC_LIST_LOADING",
    DOC_LIST_SUCCESS: "DOC_LIST_SUCCESS",
    DOC_LIST_FAILED: "DOC_LIST_FAILED",

    DOC_TYPE_MAPPING_LOADING: "DOC_TYPE_MAPPING_LOADING",
    DOC_TYPE_MAPPING_SUCCESS: "DOC_TYPE_MAPPING_SUCCESS",
    DOC_TYPE_MAPPING_FAILED: "DOC_TYPE_MAPPING_FAILED",

    NUMBER_LOCATION_LOADING: "NUMBER_LOCATION_LOADING",
    NUMBER_LOCATION_SUCCESS: "NUMBER_LOCATION_SUCCESS",
    NUMBER_LOCATION_FAILED: "NUMBER_LOCATION_FAILED",

    SET_TIMESTAMP: "SET_TIMESTAMP",

    RENEW_NUMBER_INIT: "RENEW_NUMBER_INIT",
    RENEW_NUMBER_SUCCESS: "RENEW_NUMBER_SUCCESS",
    RENEW_NUMBER_FAILED: "RENEW_NUMBER_FAILED",
}

